import RecruitApiClient from '../../RecruitApiClient';

class Api {
  getSearches = (
    page: number = 1,
    limit: number = 20,
    sort: string = 'id',
    sortOrder: string = 'desc',
    query?: string
  ) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      sort,
      sort_order: sortOrder
    });

    if (query) {
      params.append('query', query);
    }

    return RecruitApiClient.get(`/api/v4/candidate_sourcing/searches?${params.toString()}`);
  };

  getCandidatePools = (
    page: number = 1,
    limit: number = 20,
    sort: string = 'id',
    sortOrder: string = 'desc',
    query?: string
  ) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      sort,
      sort_order: sortOrder
    });

    if (query) {
      params.append('query', query);
    }

    return RecruitApiClient.get(`/api/v4/candidate_sourcing/candidate_pools?${params.toString()}`);
  };

  getCandidatePool = (id: number) =>
    RecruitApiClient.get(`/api/v4/candidate_sourcing/candidate_pools/${id}`);

  updateCandidatePool = (id: number, data: { title: string }) =>
    RecruitApiClient.put(`/api/v4/candidate_sourcing/candidate_pools/${id}`, data);

  getCandidatePoolCandidateGroups = (
    poolId: number,
    page: number = 1,
    limit: number = 20,
    sort: string = 'id',
    sortOrder: string = 'desc',
    query?: string
  ) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      sort,
      sort_order: sortOrder
    });

    if (query) {
      params.append('q', query);
    }

    return RecruitApiClient.get(
      `/api/v4/candidate_sourcing/candidate_pools/${poolId}/candidate_groups?${params.toString()}`
    );
  };

  getCandidatePoolEmailBatches = (
    poolId: number,
    page: number = 1,
    limit: number = 20,
    query?: string
  ) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });

    if (query) {
      params.append('q[search]', query);
    }

    return RecruitApiClient.get(
      `/api/v4/candidate_sourcing/candidate_pools/${poolId}/email_batches?${params.toString()}`
    );
  };

  getCandidatePoolEmailBatchDetails = (poolId: number, emailBatchId: number) =>
    RecruitApiClient.get(
      `/api/v4/candidate_sourcing/candidate_pools/${poolId}/email_batches/${emailBatchId}`
    );

  deleteSearch = (id: number) =>
    RecruitApiClient.delete(`/api/v4/candidate_sourcing/searches/${id}`);

  deleteCandidatePool = (id: number) =>
    RecruitApiClient.delete(`/api/v4/candidate_sourcing/candidate_pools/${id}`);

  bulkEmailCandidateSourcingPools = (
    candidateSourcingPoolIds: number[],
    emailData: {
      email_template_id: number;
      subject: string;
      body: string;
    }
  ) => {
    const payload = {
      email_batch: {
        candidate_sourcing_pool_ids: candidateSourcingPoolIds,
        ...emailData
      }
    };

    return RecruitApiClient.post('/api/v4/candidate_sourcing/candidate_pools/bulk_email', payload);
  };

  getEmailTemplates = () =>
    RecruitApiClient.get('/api/v4/searches/email_templates?group_templates=true');

  getEmailTemplateDetails = (id: string) =>
    RecruitApiClient.get(`/api/v4/searches/email_templates/${id}`);
}

export default new Api();
